import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when user balance is updated.
 * @memberOf Playtech.API.events
 * @event sportsbook-analytics
 * @type {callback}
 * @param {Object} details
 * @param {string} details.eventName Name of the event.
 * @param {string} details.userName Current player's userName.
 * @param {string} details.currency Player's currency.
 * @param {Object|string} details.raw {Object|string} Other metadata.
 * @example Playtech.on('sportsbook-analytics', (data) => { ... });
 */

export const EVENT_SPORTSBOOK_ANALYTICS = 'sportsbook-analytics';

export const useOnSportsbookAnalytics = (eventTarget: EventTarget) => {
    // todo: write a type instead of any here
    const handleEvent = useCallback((response: any): void => {
        const event = new CustomEvent(EVENT_SPORTSBOOK_ANALYTICS, { detail: response });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('sportsbook-analytics', handleEvent);

        return () => publicEventsAPIService.off('sportsbook-analytics', handleEvent);
    }, [handleEvent]);
};
